(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sd-hide-empty-items"] && !Shopify.designMode) return;
  try {
    function sdHideEmptyItems() {
    for (const container of document.querySelectorAll('[data-hide-empty-items]')) {
      for (const el of container.querySelectorAll('li')) {
        const text = el.textContent.trim();

        if (text === '') {
          el.hidden = true;
          continue;
        }

        const strong = el.querySelector('strong, b');

        if (strong) {
          const valueText = el.textContent.replace(strong.textContent, '').trim();
          if (valueText === '') el.hidden = true;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sdHideEmptyItems);
  } else {
    sdHideEmptyItems();
  }
  } catch(e) { console.error(e); }
})();

})();
